import React from 'react';
import { motion } from 'framer-motion';

const CONFETTI_COLORS = [
  '#4a8ccc',
  '#7c5ce4',
  '#f28c8c',
  '#f5b95f',
  '#62c5a8',
  '#ef6fa8',
  '#f4d35e',
  '#58b7d8',
  '#9c7bd8',
  '#ff9f68',
];

const Confetti = () => (
  <div className="pointer-events-none fixed inset-0 z-30 overflow-hidden">
    {Array.from({ length: 64 }, (_, index) => {
      const angle = (index / 64) * Math.PI * 2;
      const distance = 220 + (index % 7) * 38;
      const startX = 50 + Math.cos(angle) * 3;
      const startY = 76 + Math.sin(angle) * 2;
      const endX = 50 + Math.cos(angle) * (distance / 7);
      const endY = 76 - Math.abs(Math.sin(angle) * (distance / 3)) - 12;
      const color = CONFETTI_COLORS[index % CONFETTI_COLORS.length];

      return (
        <motion.span
          key={index}
          className="absolute h-3 w-2 rounded-sm sm:h-4 sm:w-3"
          style={{
            left: `${startX}%`,
            top: `${startY}%`,
            backgroundColor: color,
          }}
          initial={{
            x: 0,
            y: 0,
            scale: 0.4,
            rotate: 0,
            opacity: 0,
          }}
          animate={{
            x: `${(endX - startX) * 1.2}vw`,
            y: `${(endY - startY) * 1.2}vh`,
            scale: [0.4, 1.2, 0.9],
            rotate: index % 2 ? 720 : -720,
            opacity: [0, 1, 1, 0],
          }}
          transition={{
            duration: 2.8 + (index % 6) * 0.2,
            delay: (index % 10) * 0.045,
            ease: [0.16, 1, 0.3, 1],
          }}
        />
      );
    })}

    <motion.div
      className="absolute left-1/2 top-[76%] h-8 w-8 -translate-x-1/2 rounded-full bg-white/80"
      initial={{ scale: 0, opacity: 0.9 }}
      animate={{ scale: [0, 5, 8], opacity: [0.9, 0.25, 0] }}
      transition={{ duration: 1.2, ease: 'easeOut' }}
    />
  </div>
);

export default Confetti;